export default "__VITE_ASSET__BgJGYtlF__"